import { Stack } from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
import DaysLookBackSummary from './7DaysLookBack';

function getLast6thDate(date: string): string {
  return moment(date).subtract(6, 'days').format('YYYY-MM-DD');
}
const SummaryCard_2_0 = ({
  totalMins = [
    {
      totalPlanMinutes: '',
      totalActualMinutes: '',
      date: new Date(),
    },
    {
      totalPlanMinutes: '',
      totalActualMinutes: '',
      date: new Date(),
    },

    {
      totalPlanMinutes: '',
      totalActualMinutes: '',
      date: new Date(),
    },

    {
      totalPlanMinutes: '',
      totalActualMinutes: '',
      date: new Date(),
    },

    {
      totalPlanMinutes: '',
      totalActualMinutes: '',
      date: new Date(),
    },

    {
      totalPlanMinutes: '',
      totalActualMinutes: '',
      date: new Date(),
    },
    {
      totalPlanMinutes: '',
      totalActualMinutes: '',
      date: new Date(),
    },
    {
      totalPlanMinutes: '',
      totalActualMinutes: '',
      date: new Date(),
    },
    {
      totalPlanMinutes: '',
      totalActualMinutes: '',
      date: new Date(),
    },
  ],
  variation = [
    { variation: '', rugsScore: '', date: new Date() },
    { variation: '', rugsScore: '', date: new Date() },
    { variation: '', rugsScore: '', date: new Date() },
    { variation: '', rugsScore: '', date: new Date() },
    { variation: '', rugsScore: '', date: new Date() },
    { variation: '', rugsScore: '', date: new Date() },
    { variation: '', rugsScore: '', date: new Date() },
    { variation: '', rugsScore: '', date: new Date() },
    { variation: '', rugsScore: '', date: new Date() },
  ],
  currentsWeekList = [],
  lookBackSum
}: any) => {
  const totalMinsResponse = totalMins?.sort((a: any, b: any) => {
    const date1: any = new Date(a?.date);
    const date2: any = new Date(b?.date);
    return date1 - date2;
  });

  const variationResponse = variation?.sort((a: any, b: any) => {
    const date1: any = new Date(a?.date);
    const date2: any = new Date(b?.date);
    return date1 - date2;
  });
  const isTodayDate = currentsWeekList?.findIndex(
    (date: any) => date === moment().format('YYYY-MM-DD')
  );

  const [copyTemplateStartDate, setCopyTemplateStartDate] = useState(null);

  const getSevenDayBack = (currentDate: any) => {
    if (!copyTemplateStartDate) return false;
    if (
      currentDate <= copyTemplateStartDate &&
      currentDate >= getLast6thDate(copyTemplateStartDate)
    )
      return true;
    return false;
  }


  return (
    <Stack
      sx={{ width: '100%', height: '120px' }}
      flexDirection="row"
    >
      <Stack
        sx={{ height: '100%' }}
        flex={1.5}
      >
        <Stack
          sx={{
            height: '33%',
            justifyContent: 'center',
            paddingLeft: '10px',
            backgroundColor: '#F8F9FA',
            borderRight: '1px solid #E5E7EB',
            borderTop: '1px solid #E5E7EB',
            fontSize: '12px',
            fontWeight: '500',
            color: '#111927',
            // borderBottom: '1px solid #E5E7EB',
          }}
        >
          Daily Total Min.
        </Stack>
        <Stack
          sx={{
            height: '33%',
            justifyContent: 'center',
            paddingLeft: '10px',
            backgroundColor: '#F8F9FA',
            borderRight: '1px solid #E5E7EB',
            fontSize: '12px',
            fontWeight: '500',
            color: '#111927',
          }}
        >
          RUGs Total
        </Stack>
        <Stack
          sx={{
            height: '33%',
            justifyContent: 'center',
            paddingLeft: '10px',
            backgroundColor: '#F8F9FA',
            borderRight: '1px solid #E5E7EB',
            fontSize: '12px',
            fontWeight: '500',
            color: '#111927',
          }}
        >
          Variation
        </Stack>
      </Stack>
      <Stack
        sx={{ height: '100%' }}
        flex={8.5}
      >
        <Stack
          sx={{
            width: '100%',
            height: '33%',
          }}
          flexDirection="row"
        >
          {totalMinsResponse?.length > 0
            ? totalMinsResponse?.map((min: any, index: number) => (
                <Stack
                  key={index}
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    backgroundColor: isTodayDate === index ? '#F5F7FF' : '#FFF',
                    borderRight: '1px solid #E5E7EB',
                    width: 'calc(100% / 7 )',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#111927',
                  }}
                >
                  {`${min?.totalPlanMinutes} | ${min?.totalActualMinutes}`}
                </Stack>
              ))
            : [
                {
                  totalPlanMinutes: '',
                  totalActualMinutes: '',
                },
                {
                  totalPlanMinutes: '',
                  totalActualMinutes: '',
                },

                {
                  totalPlanMinutes: '',
                  totalActualMinutes: '',
                },

                {
                  totalPlanMinutes: '',
                  totalActualMinutes: '',
                },

                {
                  totalPlanMinutes: '',
                  totalActualMinutes: '',
                },

                {
                  totalPlanMinutes: '',
                  totalActualMinutes: '',
                },
                {
                  totalPlanMinutes: '',
                  totalActualMinutes: '',
                },
                {
                  totalPlanMinutes: '',
                  totalActualMinutes: '',
                },
                {
                  totalPlanMinutes: '',
                  totalActualMinutes: '',
                },
              ].map((min: any, index: number) => (
                <Stack
                  alignItems="center"
                  key={index}
                  justifyContent="center"
                  sx={{
                    backgroundColor: isTodayDate === index ? '#F5F7FF' : '#FFF',
                    borderRight: '1px solid #E5E7EB',
                    width: 'calc(100% / 7 )',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#111927',
                  }}
                >
                  {min?.totalPlanMinutes === '' && min.totalActualMinutes === ''
                    ? new Date(currentsWeekList[index]) < new Date() || isTodayDate === index
                      ? `0 | 0`
                      : `0`
                    : new Date(currentsWeekList[index]) < new Date() && isTodayDate !== index
                    ? `${min.totalPlanMinutes}`
                    : `${min.totalPlanMinutes} | ${min.totalActualMinutes}`}
                </Stack>
              ))}
        </Stack>
        <Stack
          sx={{ width: '100%', height: '33%', backgroundColor: '#FFF' }}
          flexDirection="row"
        >
          {lookBackSum?.map((sumItem: any, index: number) => (
            <Stack
              alignItems="center"
              key={index}
              justifyContent="center"
              sx={{

                backgroundColor: getSevenDayBack(sumItem?.date)
                  ? 'rgba(177, 178, 248, 0.15)' : isTodayDate === index ? '#F5F7FF' : '#FFF',
                borderRight: '1px solid #E5E7EB',
                width: 'calc(100% / 7 )',
                fontSize: '14px',
                fontWeight: getSevenDayBack(sumItem?.date) ? '800' : '400',
                color: getSevenDayBack(sumItem?.date) ? '#6366F1' : '#111927',
              }}
              onMouseEnter={() => setCopyTemplateStartDate(sumItem?.date)}
              onMouseLeave={() => {
                setCopyTemplateStartDate(null);
              }}
            >
              {sumItem?.lookbackSum ? sumItem?.lookbackSum : 0}
            </Stack>
          ))
          }
        </Stack>
        <Stack
          sx={{ width: '100%', height: '33%', backgroundColor: '#FFF' }}
          flexDirection="row"
        >
          {variationResponse?.length > 0
            ? variationResponse?.map((variation: any, index: number) => (
                <Stack
                  alignItems="center"
                  key={index}
                  justifyContent="center"
                  sx={{
                    backgroundColor: isTodayDate === index ? '#F5F7FF' : '#FFF',
                    borderRight: '1px solid #E5E7EB',
                    width: 'calc(100% / 7 )',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#111927',
                  }}
                >
                  {variation?.variation ? variation?.variation : 0}
                </Stack>
              ))
            : [
                { variation: '', rugsScore: '' },
                { variation: '', rugsScore: '' },
                { variation: '', rugsScore: '' },
                { variation: '', rugsScore: '' },
                { variation: '', rugsScore: '' },
                { variation: '', rugsScore: '' },
                { variation: '', rugsScore: '' },
                { variation: '', rugsScore: '' },
                { variation: '', rugsScore: '' },
              ]?.map((variation: any, index: number) => (
                <Stack
                  key={index}
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    backgroundColor: isTodayDate === index ? '#F5F7FF' : '#F3F4F6',
                    borderRight: '1px solid #E5E7EB',
                    width: 'calc(100% / 7 )',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#111927',
                  }}
                >
                  {variation?.variation === '' ? '0' : variation?.variation}
                </Stack>
              ))}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SummaryCard_2_0;
